module.exports = __webpack_public_path__ + "img/CC.88780bd7.png";